import React, { useState } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

export const SearchField = ({ label, backgroundColor, isRequired, placeholder, errorText, ...props }) => {
    const [value, setValue] = useState("");

    const handleBlur = (e) => {
        if (props.type === "number") {
            const numberValue = parseFloat(e.target.value || "0");
            setValue(numberValue.toString());
        } else {
            setValue(e.target.value);
        }
    };

    return (
        <FormControl fullWidth error={!!errorText}>
            {label && (
                <InputLabel shrink htmlFor={props.name}>
                    <Typography variant="body2"  sx={{ textTransform: "capitalize", color: "text.secondary" }}>
                        {label}
                    </Typography>
                </InputLabel>
            )}
            <TextField
                id={props.name}
                error={!!errorText}
                placeholder={placeholder}
                sx={{
                    border: "none",
                    "& fieldset": { border: "none" },
                    "& .MuiInputBase-input": { padding: "0 0 0 14px !important",fontSize:{xs:"14px",sm:"16px"},},
                    fontWeight: "400",
                    lineHeight: "30px",
                    padding:0,
                    mt:1


                }}
                {...props}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onBlur={handleBlur}
                helperText={errorText}
            />
        </FormControl>
    );
};